// External modules
import React from 'react';
import { BodyText } from '@paypalcorp/pp-react-text-weasley-v7';

// Internal modules
import { StepBlock } from './StyledComponents';
import { icons } from '@/lib/icons';
import { ParentContainer } from '@/components/Common';
import { PP_DIVIDER_COLOR } from '@/styles';

export const StepComponent = ({
  content,
  iconName,
  margin,
}: {
  content: React.ReactNode;
  iconName: keyof typeof icons;
  margin: string;
}): JSX.Element => {
  const StepIcon = icons[iconName];
  return (
    StepIcon && (
      <StepBlock margin={margin}>
        <ParentContainer containerHeight="32px" containerWidth="32px">
          <StepIcon spotBgColor={PP_DIVIDER_COLOR} />
        </ParentContainer>
        <ParentContainer margin="0 0 0 10px">
          <BodyText> {content}</BodyText>
        </ParentContainer>
      </StepBlock>
    )
  );
};
